'use client'

import type { ReactNode } from 'react'
import { usePathname } from 'next/navigation'
import { StartWhitelabelGate } from '@/components/gates/StartWhitelabelGate'

/** Permite al propietario Start consultar su membresía sin depender de headers del middleware. */
export function StartOwnerWhitelabelGuard({
  children,
  planName,
  enabled,
}: {
  children: ReactNode
  planName: string
  enabled: boolean
}) {
  const pathname = usePathname() || '/'
  const membershipRoute =
    pathname === '/membership' || pathname.startsWith('/membership/')

  if (enabled && !membershipRoute) {
    return <StartWhitelabelGate isOwner planName={planName} />
  }

  return <>{children}</>
}
